import React, { useEffect, useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Col, Row, Skeleton, Tag, Timeline } from 'antd';
import { lessonProps } from './ lessongroup-interface';
import { useNavigate } from 'react-router-dom';
import { transformAmount } from '../../../../../utils/helper';

const Lessongroup = ({
  details,
  index,
  openLevel,
  completedIds,
  curriculumAssignmentId,
  rewards,
}: lessonProps) => {
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(false);
  const [dataItems, setDataItems] = useState<any[]>([]);
  const [currentUnit, setCurrentUnit] = useState<any>(null);
  const [currentReward, setCurrentReward] = useState<any[]>([]);

  useEffect(() => {
    setCollapsed(details.open);
  }, [details.open]);

  useEffect(() => {
    if (currentUnit !== null) {
      let relatedRewards: any[] = [];
      rewards?.forEach((item) => {
        if (
          item.active &&
          item.rewardType.toLowerCase() === currentUnit?.typeModel.toLowerCase()
        ) {
          relatedRewards.push(item);
        }
      });
      setCurrentReward(relatedRewards);
    }

    // eslint-disable-next-line
  }, [rewards, currentUnit]);

  
  const canAccessUnit = (unitId: string, unitIndex: number) => {
    const currentIndex = details.units.findIndex((unit: any) => unit.typeId._id === unitId);
  
    if (currentIndex === -1) {
      // The unit with the given unitId was not found.
      return false;
    }
  
    if (unitIndex === 0 && currentIndex === 0) {
      // For the first unit, only the first module is accessible by default.
      return true;
    }
  
    // Check if all previous modules in the preceding unit are completed.
    for (let i = currentIndex - 1; i >= 0; i--) {
      const previousUnit = details.units[i];
      const isPreviousUnitCompleted = completedIds?.some((completed: any) => completed.unitId === previousUnit.typeId._id);
      if (!isPreviousUnitCompleted) {
        return false; // Previous unit is not completed, so current unit is locked.
      }
    }
  
    // All previous units are completed, so the current unit is accessible.
    return true;
  };
  
  

  useEffect(() => {
    const newDataItems: any[] = [];
    const mainData: any[] = [];

    details.units
      .sort((a: any, b: any) => a.order - b.order)
      .forEach((item: any) => {
        const unitId = item?.typeId?._id;
        const isCompleted =
        completedIds &&
        completedIds?.filter((completed: any) => completed?.unitId === unitId).length > 0;
        const dotBackgroundColor = isCompleted ? 'bg-appcolorgreen' : (canAccessUnit(unitId,index) ? 'bg-appcolorpurpledeepone' : 'bg-gray-600');

        let obj = {
          dot: (
            <div className={`relative h-[25px] w-[25px] rounded-full ${dotBackgroundColor}`}>
            {!canAccessUnit(unitId,index) && (
              <div className='absolute z-10 top-[5px] left-[7.5px]'>
                <img src="/img/vectors/lock.svg" alt="lock" />
              </div>
            )}
          </div>

          ),
          children: (
            <div className='relative'>
              <Row>
                <Col lg={12} md={24} xs={24}>
                  <div
                    className='relative mb-8 h-[9.3rem] cursor-pointer rounded-[30px] bg-appcolorpinkdeepone p-4'
                    onClick={() => {
                      setCurrentUnit(item);
                    }}>
                    <p className='mb-2 text-base font-medium text-appcolorblackfainteleven opacity-[0.7]'>
                      {item.typeModel}
                    </p>
                    <p className='text-base text-appcolorblackfainteleven'>
                      {item?.typeId?.title}
                    </p>

                    <div className='absolute bottom-[1.2rem] right-[1rem] flex'>
                      {isCompleted ? (
                        <Tag color='success'>Completed</Tag>
                      ) : (
                        <Tag color='default'>Not Completed</Tag>
                      )}

                      <img
                        src={`/img/vectors/${
                          isCompleted ? 'lessondone.svg' : 'lessonpending.svg'
                        }`}
                        alt='status'
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          ),
        };

        newDataItems.push(obj);
        mainData.push(item);
      });

    setDataItems(newDataItems);

    if (mainData.length > 0) {
      setCurrentUnit(mainData[0]);
    }
    // eslint-disable-next-line
  }, [completedIds]);

 

  const runNavigate = (
    typeModel: string,
    _id: string,
    curriculumAssignmentId: string
  ) => {
    if (typeModel === 'RamRun') {
      navigate(
        `/student/dashboard/ramruns/${_id}?curriculumAssignmentId=${curriculumAssignmentId}`
      );
    }
    if (typeModel === 'Lesson') {
      navigate(`/ide/${_id}?curriculumAssignmentId=${curriculumAssignmentId}`);
    }
  };

  

  return (
    <div className={`${collapsed ? 'mb-6' : 'mb-6'}`}>
      <div
        className='custom-grey-bg-faint flex w-full cursor-pointer items-center justify-between rounded-[20px] px-[1.25rem] py-[0.75rem]'
        onClick={() => {
          if (canAccessUnit(currentUnit?.typeId?._id, index)) {
            openLevel(index, !collapsed);
          }
        }}>
        <div className='flex items-center text-[20px] font-semibold leading-[26px] '>
          <p className='mr-[0.5rem] text-appcolorblack'>Unit {index + 1}:</p>
          <p className='capitalize text-appcolorgreyfaintfour'>
            {details?.name}
          </p>
        </div>

        <div className='flex items-center'>
          <p className='mr-[1.5rem] text-appcolorgreyfaintfour'>
            {dataItems.length}
          </p>
          {collapsed ? <DownOutlined /> : <UpOutlined />}
        </div>
      </div>

      {collapsed ? (
        <>
          <div className='mt-[1.7rem]'>
            <Row gutter={16}>
              <Col lg={13} md={24} xs={24}>
                <div
                  style={{
                    maxHeight: '90%',
                    overflowY: 'scroll',
                    position: 'relative',
                    padding: '2rem',
                  }}>
                  <Timeline pending={true} items={dataItems} />
                </div>
              </Col>
              <Col lg={11} md={24} xs={24}>
                {currentUnit === null ? (
                  <></>
                ) : (
                  <div className=''>
                    <div className='mb-[0.9rem]'>
                      <img
                        src='/img/vectors/aboutpython.svg'
                        alt='title'
                        className='w-full rounded-[30px]'
                      />
                    </div>

                    <div className='custom-grey-bg-faint mt-[-3rem] px-[1.2rem] pb-[1.2rem] pt-[3rem]'>
                      <p className='mb-[0.9rem] text-base font-bold text-appcolorblackfainteleven'>
                        {currentUnit?.typeId?.title}
                      </p>

                      {canAccessUnit(currentUnit?.typeId?._id,index) ? (
                        <div>

                      <p className='mb-[1.4rem] text-base text-appcolorblackfainteleven'>
                        {currentUnit?.typeId?.description}
                      </p>

                      <div className='mb-[1.4rem] flex items-center'>
                        {currentReward.map((item) =>
                          item.rewardItems.map((itemInside: any) => (
                            <div className='mr-[0.7rem] flex items-center rounded-[20px] bg-appcolorblackfaintfive px-[0.8rem] pb-[0.4rem] pt-[0.3rem]'>
                              <div className='mr-[0.4rem]'>
                                <img
                                  src='/img/vectors/star.svg'
                                  alt='key'
                                  className='h-[0.8rem] w-[0.8rem]'
                                />
                              </div>
                              <span className='text-base font-bold text-appcolorpurplefaintone opacity-[0.5]'>
                                {transformAmount(
                                  itemInside?.rewardItemFunPoints ?? 0
                                )}{' '}
                                -{' '}
                                <span className='capitalize'>
                                  {itemInside?.rewardItemType}
                                </span>
                              </span>
                            </div>
                          ))
                        )}
                      </div>

                      {currentUnit?.typeModel === 'RamRun' && (
                        <div className='flex w-max items-center rounded-[20px] bg-appcolorblackfaintfive px-[0.8rem] pb-[0.4rem] pt-[0.3rem]'>
                          
                          <p className='text-base font-bold text-appcolorpurplefaintone opacity-[0.5]'>
                            {currentUnit?.typeId?.questions.length} Questions
                          </p>{' '}
                        </div>
                      )}
                      <div className='flex justify-end'>
                        <Button
                          className='custom-primary-btn'
                          onClick={() => {
                            runNavigate(
                              currentUnit?.typeModel,
                              currentUnit?.typeId?._id,
                              curriculumAssignmentId || ''
                            );
                          }}>
                          Start
                        </Button>
                      </div>
                    </div>
                      ) : (
                        <div>
                        <p className='mb-[1.4rem] text-base text-appcolorblackfainteleven'>
                          This unit is locked. Complete the previous unit to unlock it.
                        </p>
                      </div>
                      )}
                      </div>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default Lessongroup;
